import React from "react";
import PropTypes from "prop-types";
import { browserHistory } from "react-router";
import {
  Avatar,
  ListItem,
  ListItemAvatar,
  Popover,
  MenuList,
  MenuItem,
  Button,
} from "@mui/material";
import {
  Person,
  Redeem,
  History,
  FavoriteBorder,
  LocalActivity,
} from "@mui/icons-material";

import find from "lodash/find";
import map from "lodash/map";
import get from "lodash/get";
// import RSSelectField from 'components/RSSelectField';

import { FormattedMessage } from "react-intl";

import PointsLabelHeader from "components/PointsLabelHeader";
import AppBarStyled from "./AppBarStyled";
import messages from "./messages";
import RoundedButton from "../ButtonRounded";

const styles = {
  titleStyle: {
    cursor: "pointer",
    textAlign: "center",
    fontSize: 16,
    color: "#000000",
    paddingTop: 2,
  },
  iconStyleLeft: {
    flex: 1,
  },
  iconStyleLeftInner: {
    padding: "18px 16px 16px 20px",
    color: "#000000",
    fontSize: 14,
  },
  iconStyleLeftAvatar: {
    width: 30,
    height: 30,
    border: "1px solid #000",
    boxShadow: "0 3px 2px #FFE500",
  },
  iconStyleRight: {
    flex: 1,
    textAlign: "right",
  },
  logo: {
    // width: '150px',
    height: "40px",
  },
};

let lastScrollY = 0;

class HeaderDefault extends React.PureComponent {
  constructor(props) {
    super(props);
    this.renderPointsPerCategory = this.renderPointsPerCategory.bind(this);
    this.handleTouchTap = this.handleTouchTap.bind(this);
    this.handleRequestClose = this.handleRequestClose.bind(this);
    this.handleScroll = this.handleScroll.bind(this);

    this.state = {
      showShadow: false,
      open: false,
    };
    this.withShadow = false;
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll, true);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll(event) {
    lastScrollY = event.target.scrollTop;
    if (lastScrollY > 70 && !this.withShadow) {
      this.setState({
        showShadow: true,
      });
      this.withShadow = true;
    } else if (this.withShadow && lastScrollY < 70) {
      this.setState({
        showShadow: false,
      });
      this.withShadow = false;
    }
  }

  handleTouchTap(event) {
    // This prevents ghost click.
    event.preventDefault();
    this.setState({
      open: true,
      anchorEl: event.currentTarget,
    });
  }

  handleRequestClose() {
    this.setState({
      open: false,
    });
  }

  goToHome() {
    browserHistory.push("/home/all");
  }

  goToLogin() {
    browserHistory.push("/login");
  }

  onCategorySelected(category) {
    this.props.onTTloggerEventLog("pageview", category);
    browserHistory.push(`/home/${category}`);
  }

  onMenuItemSelected(value) {
    this.handleRequestClose();
    this.props.onMenuItemSelected(value);
  }

  // /////////////////
  // render

  render() {
    return (
      <header>
        <AppBarStyled
          title={styles.titleStyle}
          onClick={this.goToHome}
        >
          <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
            {this.renderElementLeft()}
            {this.renderElementRight()}
          </div>
        </AppBarStyled>
        {this.renderUserMenu()}
      </header>
    );
  }

  renderElementLeft() {
    const { user /* , locale */ } = this.props;

    if (!user) {
      return this.renderButtonLogin();
    }
    return (
      <div style={{ display: "flex" }}>
        <ListItem
          style={styles.iconStyleLeftInner}
          onClick={this.handleTouchTap}
        >
          <ListItemAvatar>{this.renderUserAvatar()}</ListItemAvatar>
          <FormattedMessage {...messages.helloUser} />
          <b>{user.screenname}!</b>
        </ListItem>
        {/* <RSSelectField
          customStyles={{ width: '92px', margin: 0, padding: 0, display: 'inline-block', verticalAlign: 'middle' }}
          items={languages}
          bordered={false}
          itemSelected={locale}
          onChange={this.props.onChangeLanguage}
        />*/}
      </div>
    );
  }

  renderUserAvatar() {
    const {
      user: { imageUrl },
    } = this.props;
    if (imageUrl) {
      return <Avatar style={styles.iconStyleLeftAvatar} src={imageUrl} />;
    }
    return <Avatar style={styles.iconStyleLeftAvatar} icon={<Person />} />;
  }

  checkCaregiverFlow() {
    const {
      user: { isPpAccepted, isTosAccepted },
    } = this.props;
    if (Number(isTosAccepted) === 0) {
      return this.onMenuItemSelected("/pages/tos");
    }
    if (Number(isPpAccepted) === 0) {
      return this.onMenuItemSelected("/pages/privacy");
    }
    return this.onMenuItemSelected("/register-girls");
  }

  renderUserMenu() {
    /* const { user } = this.props;
   let userGroup;
     if (user) {
       userGroup = user.userGroup;
     }*/
    return (
      <Popover
        open={this.state.open}
        anchorEl={this.state.anchorEl}
        anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
        onClose={this.handleRequestClose}
      >
        <MenuList>
          <MenuItem
            style={{ padding: 15 }}
            onClick={() => this.onMenuItemSelected("/redemptions")}
          >
            <Redeem style={{ marginLeft: 5, marginRight: 20 }} />
            <FormattedMessage {...messages.menuItemRedemptions} />
          </MenuItem>
          <MenuItem
            style={{ padding: 15 }}
            onClick={() => this.onMenuItemSelected("/points")}
          >
            <History style={{ marginLeft: 5, marginRight: 20 }} />
            <FormattedMessage {...messages.menuItemPoints} />
          </MenuItem>
          <MenuItem
            style={{ padding: 15 }}
            onClick={() => this.onMenuItemSelected("/favorites")}
          >
            <FavoriteBorder style={{ marginLeft: 5, marginRight: 20 }} />
            <FormattedMessage {...messages.menuItemFavorites} />
          </MenuItem>
          <MenuItem
            style={{ padding: 15 }}
            onClick={() => this.onMenuItemSelected("/lotteries")}
          >
            <LocalActivity style={{ marginLeft: 5, marginRight: 20 }} />
            <FormattedMessage {...messages.menuItemLotteries} />
          </MenuItem>
        </MenuList>
      </Popover>
    );
  }

  renderElementRight() {
    const { pathname } = this.props;
    if (/login/i.test(pathname)) {
      return <div />;
    }
    const { user } = this.props;
    if (user) {
      return this.renderPoints();
    }
    return <div />;
  }

  renderPoints() {
    const { categories } = this.props;
    return (
      <div style={{ marginTop: 7 }}>
        {map(categories, this.renderPointsPerCategory)}
      </div>
    );
  }

  renderPointsPerCategory(category) {
    const { user } = this.props;
    const points = get(
      find(user.points, { rewardCategoryId: category.id }),
      "points"
    );

    return (
      <Button
        key={category.id}
        onClick={() => this.onCategorySelected(category.id)}
      >
        <PointsLabelHeader
          name={category.name}
          points={points}
          style={{ color: "#000", fontWeight: "bold", fontSize: 16 }}
        ></PointsLabelHeader>
      </Button>
    );
  }

  renderButtonLogin() {
    return (
      <RoundedButton
        color="#000"
        style={{ fontSize: 14 }}
        label={this.renderMessage(messages.actionLogin)}
        onClick={this.goToLogin}
        className="header-loginbtn"
      />
    );
  }

  renderMessage(message) {
    return <FormattedMessage {...message}></FormattedMessage>;
  }
}

HeaderDefault.propTypes = {
  user: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  categories: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
  // locale: PropTypes.string,
  pathname: PropTypes.string,
  onMenuItemSelected: PropTypes.func.isRequired,
  onTTloggerEventLog: PropTypes.func.isRequired,
  // onChangeLanguage: PropTypes.func.isRequired,
};

export default HeaderDefault;
